import {Box, InputBase, Typography} from '@mui/material';
import {Fragment} from 'react';
import {useTranslation} from 'react-i18next';
import {ReactComponent as DeclineIcon} from '../../assets/icons/decline.svg';
import {ReactComponent as SearchIcon} from '../../assets/icons/search.svg';
import Bakery from '../../models/entities/bakery';
import City from '../../models/entities/city';
import Icon from '../common/Icon';
import IconButton from '../common/IconButton';

export type SearchFieldProps = {
  searchText: string;
  setSearchText: (searchText: string) => void;
  selectedCity?: City;
  selectedBakery?: Bakery;
  onReturnToBakeries: () => void;
  onReturnToCountries: () => void;
};

function SearchField(props: SearchFieldProps) {
  const {
    searchText,
    setSearchText,
    selectedCity,
    selectedBakery,
    onReturnToBakeries,
    onReturnToCountries,
  } = props;
  const {t} = useTranslation();

  return (
    <Box
      sx={{
        display: 'flex',
        alignItems: 'center',
        gap: '8px',
        height: '40px',
        padding: '12px 32px',
        backgroundColor: 'custom.surfaceQuaternary',
        borderRadius: '360px',
      }}>
      {selectedCity != null && (
        <Fragment>
          <Typography
            sx={{
              fontSize: '16px',
              fontStyle: 'normal',
              fontWeight: 500,
              lineHeight: 'normal',
              cursor: 'pointer',
            }}
            noWrap
            onClick={onReturnToBakeries}>
            {selectedCity.name}
          </Typography>
          <Typography
            sx={{
              fontSize: '19px',
              fontStyle: 'normal',
              fontWeight: 400,
              lineHeight: '24px',
            }}>
            |
          </Typography>
        </Fragment>
      )}
      {selectedBakery != null ? (
        <Fragment>
          <Typography
            sx={{
              flex: 1,
              fontSize: '16px',
              fontStyle: 'normal',
              fontWeight: 400,
              lineHeight: '24px',
            }}
            noWrap>
            {selectedBakery.name}
          </Typography>
          <IconButton
            IconComponent={DeclineIcon}
            activeColor="custom.iconsPrimary"
            onClick={onReturnToCountries}
          />
        </Fragment>
      ) : (
        <Fragment>
          <InputBase
            sx={{
              flex: 1,
              fontSize: '16px',
              fontStyle: 'normal',
              fontWeight: 400,
              lineHeight: '24px',
              color: 'custom.textTertiary',
            }}
            placeholder={t('bakeries_search_field_placeholder')}
            value={searchText}
            onChange={(event) => setSearchText(event.target.value)}
          />
          <Icon IconComponent={SearchIcon} />
        </Fragment>
      )}
    </Box>
  );
}

export default SearchField;
